import { Component, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormControl, FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BrandService } from '../../services/brand/brand.service';
import { SharedService } from '../../services/shared.service';
import { WalPageService } from '../../services/session/wal-page.service';
import { DataExchangeService } from '../../services/session/data-exchange.service';
import { AccountTasksService } from '../../services/account/account-tasks.service';
import { SessionAuthService } from '../../services/session/session-auth.service';
import { ComponentSectionFactoryService } from '../../services/component-section-factory.service';
import { HeaderSectionDirective } from '../../directives/header-section.directive';
import { FooterSectionDirective } from '../../directives/footer-section.directive';
import { IComponentSection } from '../../interfaces/component-section';
import { IBrandInfo } from '../../interfaces/brand/brand-info';
import { IMessageBroadcasting } from '../../interfaces/message/message-broadcasting';
import { IVarValue } from '../../interfaces/var-value';
import { VarValueItemComponent } from '../section-blocks/var-value-item/var-value-item.component';
import { NgClass } from '@angular/common';
import { ThemeDirective } from '../../directives/theme.directive';
import { ISessionDetails } from '../../interfaces/session-details';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-account-tasks',
    standalone: true,
    templateUrl: './account-tasks.component.html',
    styleUrls: ['./account-tasks.component.css'],
    imports: [ThemeDirective, HeaderSectionDirective, ReactiveFormsModule, NgClass, VarValueItemComponent, FooterSectionDirective]
})
export class AccountTasksComponent implements OnInit {

  @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly sessionAuthService = inject(SessionAuthService);
  private readonly walPageService = inject(WalPageService);
  private readonly brandService = inject(BrandService);
  private readonly sharedService = inject(SharedService);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly componentSectionFactoryService = inject(ComponentSectionFactoryService);
  private readonly accountTasksService = inject(AccountTasksService);
  private readonly logger = inject(NGXLogger);
  private readonly destroyRef = inject(DestroyRef);

  region!: string;
  brandCode!: string;
  extAccountId!: string;
  sessionId!: string;

  brandStyleTheme: any = {};

  passTemplates: any[] = [];
  messageTemplates: any[] = [];
  msgTemplates: any[] = [];
  varValues: IVarValue[] = [];
  origVarValues: any[] = [];

  standardAmounts!: any[];  
  amountDueChange: number = 54.11;

  notifForm!: FormGroup;

  isTemplateShown!: boolean;

  messageOneText!: string;
  isSuccessMessageOneShown: boolean = false;
  isDangerMessageOneShown = false;

  messageTwoText!: string;
  isSuccessMessageTwoShown: boolean = false;
  isDangerMessageTwoShown = false;

  messageThreeText!: string;
  isSuccessMessageThreeShown: boolean = false;
  isDangerMessageThreeShown = false;

  messageFourText!: string;
  isSuccessMessageFourShown: boolean = false;
  isDangerMessageFourShown = false;

  constructor(
    private fb: FormBuilder,
    // private activatedRoute: ActivatedRoute,
    // private brandService: BrandService,
    // private sharedService: SharedService,
    // private componentSectionFactoryService: ComponentSectionFactoryService,
    // private accountTasksService: AccountTasksService
    ){
  }

  ngOnInit() {
    // Prepopulate the standardAmounts 
    this.standardAmounts = [
      { industry: 'Auto', standardAmount: 358.22},
      { industry: 'CreditCard', standardAmount: 787.25},
      { industry: 'Gift', standardAmount: 215.39},
      { industry: 'Insurance', standardAmount: 358.22},
      { industry: 'Mortgage', standardAmount: 2231.56},
      { industry: 'Other', standardAmount: 215.39},
      { industry: 'Prepaid', standardAmount: 215.39},
      { industry: 'Utility', standardAmount: 215.39}
    ];    

    this.notifForm = this.fb.group({
      'passId': new FormControl('', [Validators.required, Validators.min(1)]),
      'messageTemplateCode': new FormControl('', [Validators.required]),
      'templateHeader': new FormControl('', [Validators.required]),
      'templateText': new FormControl('', [Validators.required]),
    });
    this.notifForm.setValue({
      passId: 0, messageTemplateCode: '', templateHeader: '', templateText: ''
    });

    // Get the parameters from the caller (Walletron)
    this.activatedRoute.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.region = params.get('r') || '';
        this.sessionId = params.get('si') || '';

        // Get session details to find out the auth token
        // this.getSessionDetails(this.region, this.sessionId);
        this.sessionAuthService.getWalPageSession(this.region, this.sessionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
        next: () => {
          // Retrieve account tasks session
          this.getAccountTasksSession();
        },
        error: (error) => {
          this.router.navigate(['/err']);
        }
      });
    });
 
  }

  // public getSessionDetails(region: string, sessionId: string) {
  //   this.walPageService.getSessionDetails(region, sessionId)
  //   .subscribe({
  //     next: (response) => {
  //       this.dataExchangeService.setSession(response);
  //       if (response) {
  //         let sessionDetails: ISessionDetails = response;
  //         // Find out the auth token
  //         if (sessionDetails.options) {
  //           const options: Map<string, string> = new Map(Object.entries(sessionDetails.options));
  //           if (options) {
  //             if (options.has("auth")) {
  //               let authToken: string = options.get('auth') || '';
  //               this.dataExchangeService.setAuthToken(authToken);
  //               // Retrieve account tasks session
  //               this.getAccountTasksSession();
  //             }
  //           }
  //         }
  //       }
  //     },
  //     error: (error) => {
  //       this.dataExchangeService.setMessageText(error);
  //       this.router.navigate(['/err']);
  //     },
  //     complete: () => {
  //     }
  //   });
  // }  


  getAccountTasksSession() {
    this.passTemplates = [];
    this.accountTasksService.getAccountTasksSession(this.region, this.sessionId)
    .subscribe(response => {
      if (response) {
        // Create form header and footer
        this.brandCode = response.brandCode;
        this.extAccountId = response.extAccountId;
        this.makeHeaderAndFooter();
        // Populate pass templates dropdown
        if (response.passTemplates) {
          response.passTemplates.forEach (item => {
            this.passTemplates.push({"label": item.passName, "value": item.passId});
          })
        }
        if (this.passTemplates.length == 1) {
          let passTemplateId = this.passTemplates[0].value; 
          this.notifForm.patchValue({
            passId: passTemplateId,
          });
          this.getMessageTemplates(passTemplateId);
        }
        // Get account var values
        this.getAccountVariables();
      }
    });
  }

  getAccountVariables() {
    let seqNo: number = 0;
    this.varValues = [];
    this.accountTasksService.getAccountInfo(this.region, this.brandCode, this.extAccountId)
    .subscribe({
      next: (response) => {
        if (response == null || response.customerPassInfoList == null || response.customerPassInfoList.length < 1) {
          this.varValues = [];
          this.origVarValues = [];
        } else {
          let customerpasses = response.customerPassInfoList;
          let customerpass = customerpasses[0];
          let vpipFullList = customerpass.vpivInfoList || [];
          if (vpipFullList) {
            // Get a list of distinct variable names
            var vpipDistinctNames = new Set(vpipFullList.map(x => x.variableName));
            // Loop by a specific variable to find out its latest version to populate two arrays: one to hold existing values, the other - new values
            // vpipDistinctNames.forEach(variableName => {
            //   let oneVpip = vpipFullList.filter(item => item.variableName == variableName).sort((a, b) => (a.versionNum < b.versionNum) ? 1 : -1); 
            //   this.origVarValues.push({vpivId: oneVpip[0].vpivId, variableName: oneVpip[0].variableName, variableValue: oneVpip[0].variableValue});
            //   oneVpip[0].seqNo = seqNo++;
            //   this.varValues.push(oneVpip[0]);
            // })
            for (const variableName of vpipDistinctNames) {
              const oneVpip = vpipFullList
                .filter(item => item.variableName === variableName)
                .sort((a, b) => b.versionNum - a.versionNum); // descending
              const top = oneVpip[0]; 
              if (!top) {
                continue;
              }
              this.origVarValues.push({
                vpivId: top.vpivId,
                variableName: top.variableName,
                variableValue: top.variableValue,
              });
              top.seqNo = seqNo++;
              this.varValues.push(top);
            }
          }
        }
      },
      error: (error) => {
        },
      complete: () => {
      }
    });
  }

  makeHeaderAndFooter() {
    this.brandService.getBrandInfo(this.region, this.brandCode, "NPE,WAL_PAGES,EAUTH")
    .subscribe(brandInfo => {
      if (brandInfo) {
        this.brandStyleTheme = this.sharedService.getBrandStyleScheme(brandInfo);
        this.componentSectionFactoryService.loadHeaderSection(brandInfo, this.headerComponentSection);
        this.componentSectionFactoryService.loadFooterSection(brandInfo, this.footerComponentSection);
      }
    });
  }

  onChangePassTemplate(event:any) {
    let val: string = event.target.value;
    let passTemplateId = Number(val.substring(val.indexOf(':') + 1));
    this.getMessageTemplates(passTemplateId);
  }

  // Retrieve message templates based on the chosen pass template
  getMessageTemplates(passTemplateId: number) {
    this.isTemplateShown = false;
    this.messageTemplates.length = 0;
    // Call the service to invoke a Web API call
    this.accountTasksService.getMessageTemplates(this.region, this.brandCode, passTemplateId)
    .subscribe({
      next: (response) => {
        if (response) {
          this.msgTemplates = response;
          response.forEach(element => {
              this.messageTemplates.push({label: element.messageTemplateName, value: element.messageTemplateCode});
            });
          switch(response.length) {
            case 1:
              // messageTemplateCode: response[0].messageTemplateCode, 
              // templateHeader: response[0].messageTemplateHeader, 
              // templateText: response[0].messageTemplateText
              const resp = response[0];
              if (resp) {
                this.notifForm.patchValue({
                  messageTemplateCode: resp.messageTemplateCode, 
                  templateHeader: resp.messageTemplateHeader, 
                  templateText: resp.messageTemplateText
                });
              } else {
                this.notifForm.patchValue({messageTemplateCode: ''});
              }
              break;
            case 0:
              this.messageTemplates.push({label: '[none]', value: ''});
              this.notifForm.patchValue({messageTemplateCode: ''});
              break;
            default:
              break;
          } 
        }
      },
      error: (error) => {
        // this.alertTheUser(error.message);
      },
      complete: () => {
      }
    });
  }  

  onChangeMessageTemplate(event:any) {
    let val: string = event.target.value;
    let messageTemplateCode = val.substring(val.indexOf(':') + 1).trim();
    let msgTemplatesFiltered = this.msgTemplates.filter(item => item.messageTemplateCode == messageTemplateCode);
    if (msgTemplatesFiltered.length == 1) {
      this.notifForm.patchValue({
        templateHeader: msgTemplatesFiltered[0].messageTemplateHeader, 
        templateText: msgTemplatesFiltered[0].messageTemplateText
      });
      this.isTemplateShown = true;
    }
  }

  onSubmitNotification(event: any) {
    this.messageOneText = '';
    this.isSuccessMessageOneShown = false;
    this.isDangerMessageOneShown = false;
    let messageBroadcasting: IMessageBroadcasting = {
      passId: this.notifForm.value.passId,
      messageTemplateCode: this.notifForm.value.messageTemplateCode,
      templateHeader: this.notifForm.value.templateHeader,
      templateText: this.notifForm.value.templateText,
      accountId: this.extAccountId 
    };
    // Call the service to invoke a Web API call
    this.accountTasksService.broadcastMessage(this.region, this.brandCode, messageBroadcasting)
    .subscribe({
      next: (response) => {
        this.messageOneText = 'Successfully submitted the message for brand ' + this.brandCode + ' and account ' + this.extAccountId 
        this.isSuccessMessageOneShown = true;
      },
      error: (error) => {
        this.messageOneText = error.message; 
        this.isDangerMessageOneShown = true;
      },
      complete: () => {
      }
    });
  }

  changeVarValueHandler(varValueObj: IVarValue) {
    if (varValueObj) {
      this.varValues.forEach(item => {
        if(item.vpivId == varValueObj.vpivId) {
          item.variableValue = varValueObj.variableValue;
        }
      })
    }
  }

  onSubmitDataUpdate(event: any) {
    this.messageThreeText = '';
    this.isSuccessMessageThreeShown = false;
    this.isDangerMessageThreeShown = false;
    let map = new Map<string, string>();  
    let isVarValueModified: boolean = false;
    this.varValues.forEach(item => {
      let origVar = this.origVarValues.filter(oVar => oVar.vpivId == item.vpivId);
      if (origVar.length > 0) {
        if (item.variableValue != origVar[0].variableValue) {
          // map.set(item.variableName, item.variableValue);
          isVarValueModified = true;
        }
      }
      map.set(item.variableName, item.variableValue);
    });
    if (isVarValueModified) {
    // Call the service to invoke a Web API call
    this.accountTasksService.updateAccount(this.region, this.brandCode, this.extAccountId, map)
    .subscribe({
      next: (response) => {
        this.getAccountVariables();
        this.messageThreeText = 'Successfully submitted variable value updates for brand ' + this.brandCode + ' and account ' + this.extAccountId 
        this.isSuccessMessageThreeShown = true;
      },
      error: (error) => {
        this.messageThreeText = error.message; 
        this.isDangerMessageThreeShown = true;
      },
      complete: () => {
      }
    });
    } else {
      this.messageThreeText = 'No variable value has been modified.  Please modify at least one variable, then resubmit the request.'
      this.isSuccessMessageThreeShown = true;
    }

  }

  onPaid() {
    this.runScenario('paid');
  }

  onPastDue() {
    this.runScenario('pastdue');
  }

  onCycle() {
    this.runScenario('cycle'); 
  }

  onReset() {
    this.runScenario('reset');
  }

  runScenario(scenarioName: string) {
    this.messageTwoText = '';
    this.isSuccessMessageTwoShown = false;
    this.isDangerMessageTwoShown = false;    
    let standardAmountsMap = new Map<string, string>();  
    this.standardAmounts.forEach(item => {
      standardAmountsMap.set(item.industry, item.standardAmount);
    });
    // Call the service to invoke a Web API call
    this.accountTasksService.runScenario(this.region, this.brandCode, this.extAccountId, scenarioName,
      this.amountDueChange, standardAmountsMap)
      .subscribe({
        next: (response) => {
          this.messageTwoText = 'Successfully ran the ' + scenarioName + ' scenario for brand ' + this.brandCode + ' and account ' + this.extAccountId 
          this.isSuccessMessageTwoShown = true;
       },
        error: (error) => {
          this.messageTwoText = error.message; 
          this.isDangerMessageTwoShown = true;
          },
        complete: () => {
        }
      });
  }


  onDaqDataBatchRefresher() {
    this.executeTask('DaqDataBatchRefresher');
  }

  onGenericDaqDatafeedImporter() {
    this.executeTask('GenericDaqDatafeedImporter');
  }

  onGenericOutgoingDatafeedGenerator() {
    this.executeTask('GenericOutgoingDatafeedGenerator');
  }

  onAndroidPayScanner() {
    this.executeTask('AndroidPayScanner');
  }

  executeTask (selectedTask: string) {
    this.messageFourText = '';
    this.isSuccessMessageFourShown = false;
    this.isDangerMessageFourShown = false;    
    // Call the service to invoke a Web API call
    this.accountTasksService.triggerEvent(this.region, this.brandCode, selectedTask)
      .subscribe({
        next: (response) => {
          this.messageFourText = 'Successfully triggered event ' + selectedTask + ' for brand ' + this.brandCode; 
          this.isSuccessMessageFourShown = true;
       },
        error: (error) => {
          this.messageFourText = error.message; 
          this.isDangerMessageFourShown = true;
          },
        complete: () => {
        }
      });
  }


}
